import React, { useState, useEffect, useCallback } from 'react';
import { Alert, Tooltip, Row, Modal, ModalHeader, ModalBody, FormFeedback,Badge, Container, Col, Button, FormGroup, Label, Input } from 'reactstrap';
import { Link } from 'react-router-dom';
import { withFormik, FieldArray } from 'formik';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import axios from 'axios';
import * as Yup from 'yup';
import isilogo from './images/ISI_LOGO_2.jpg';
import 'bootstrap/dist/css/bootstrap.min.css';

const scrollToTop = () => {
  if (typeof window !== 'undefined' && window.scrollTo) {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
};

const RinnovoAssociati = (props) => {
  const {
    values,
    touched,
    errors,
    status,
    handleChange,
    handleBlur,
    handleSubmit,
    setFieldValue,
    isSubmitting,
    setStatus,
  } = props;

  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  const [tooltipOpen, setTooltipOpen] = useState([]); // Array per gestire i tooltip per ogni pulsante

  const { executeRecaptcha } = useGoogleReCaptcha();
  // Stato per gestire il timestamp del token e la sua validità
  const [tokenTimestamp, setTokenTimestamp] = useState(null);
  const TOKEN_VALIDITY_DURATION = 110000; // 110 secondi

  const handleSubmitWithRecaptcha = async (event) => {
    event.preventDefault();

    if (!executeRecaptcha) {
      console.error('reCAPTCHA non è pronto');
      setStatus({ res: false, msg: 'Errore reCAPTCHA. Riprova più tardi.' });
      scrollToTop();
      return;
    }

    try {
      const now = Date.now();

      // Controlla se il token è ancora valido
      if (!values.recaptcha || !tokenTimestamp || now - tokenTimestamp >= TOKEN_VALIDITY_DURATION) {
        console.log('Token reCAPTCHA scaduto, generazione di un nuovo token...');
        const token = await executeRecaptcha('submit');
        setFieldValue('recaptcha', token);
        setTokenTimestamp(now); // Aggiorna il timestamp
      }

      // Procedi con l'invio del modulo
      handleSubmit(event);
    } catch (error) {
      console.error('Errore durante la verifica reCAPTCHA:', error);
      setStatus({ res: false, msg: 'Errore durante la verifica reCAPTCHA. Riprova.' });
    }
  };

  const scrollToTop = () => {
    if (typeof window !== 'undefined' && window.scrollTo) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const ReCaptchaField = ({ setFieldValue, values }) => {
    const { executeRecaptcha } = useGoogleReCaptcha();
  
    const handleReCaptchaVerify = useCallback(async () => {
      const now = Date.now();
  
      // Controlla se il token è ancora valido
      if (values.recaptcha && tokenTimestamp && now - tokenTimestamp < TOKEN_VALIDITY_DURATION) {
        console.log('Token reCAPTCHA ancora valido, nessuna nuova chiamata necessaria.');
        return;
      }
  
      if (!executeRecaptcha) {
        console.error('reCAPTCHA non è pronto');
        return;
      }
  
      try {
        const token = await executeRecaptcha('submit');
        setFieldValue('recaptcha', token); // Aggiorna il valore in Formik
        setTokenTimestamp(now); // Aggiorna il timestamp
        console.log('Token reCAPTCHA aggiornato');
      } catch (error) {
        console.error('Errore durante la generazione del token reCAPTCHA:', error);
      }
    }, [executeRecaptcha, setFieldValue, values.recaptcha]);
  
    // Genera il token solo una volta al montaggio del componente
    useEffect(() => {
      handleReCaptchaVerify();
    }, [handleReCaptchaVerify]);
  
    return null;
  };
  
   // Funzione per gestire il toggle del tooltip
   const toggleTooltip = (index) => {
    setTooltipOpen((prevState) => {
      const newArray = [...prevState];
      newArray[index] = !newArray[index]; // inverte il selezionato
      newArray.map((_, i) => i === index ? newArray[i] : false) // inizializza gli altri
      return newArray;
    });
  };

  return (
      <Container className="border">
      <Row>
        <Col xs="auto">
          <img className="isilogo" src={isilogo} width="120" alt="Logo Il sorriso di Isa" />
        </Col>
        <Col className="d-flex align-items-center">
          <h2>Modulo di Rinnovo Il sorriso di Isa ETS</h2>
        </Col>
      </Row>
      <form className="m-3" onSubmit={handleSubmitWithRecaptcha}>
      <Alert color="success" isOpen={status?.res ? true : false}>
        {status?.msg || ''}
      </Alert>
      <Alert color="danger" isOpen={status && !status.res ? true : false}>
        {status?.msg || ''}
        <p>Per i nuovi iscritti occorre utilizzare la form di iscrizione: <Link to="/">Iscrivi</Link></p>
      </Alert>
        {/* Gestione multipla di associati */}
        <FieldArray
          name="associati"
          render={(arrayHelpers) => (
            <div>
              {values.associati && values.associati.length > 0 ? (
                values.associati.map((associato, index) => (
                  <div key={index}>
                    <FormGroup row>
                      <Col xs="12" sm="3" md="2">
                        <Label for={`associati.${index}.nome`}>Nome</Label>
                        <Input
                          id={`associati.${index}.nome`}
                          name={`associati.${index}.nome`}
                          value={associato.nome}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          valid={!errors.associati?.[index]?.nome && touched.associati?.[index]?.nome}
                          invalid={errors.associati?.[index]?.nome && touched.associati?.[index]?.nome}
                        />
                      </Col>
                      <Col xs="12" sm="4" md="3">
                        <Label for={`associati.${index}.cognome`}>Cognome</Label>
                        <Input
                          id={`associati.${index}.cognome`}
                          name={`associati.${index}.cognome`}
                          value={associato.cognome}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          valid={!errors.associati?.[index]?.cognome && touched.associati?.[index]?.cognome}
                          invalid={errors.associati?.[index]?.cognome && touched.associati?.[index]?.cognome}
                        />
                      </Col>
                      <Col xs="12" sm="4" md="3">
                        <Label for={`associati.${index}.codice_fiscale`} translate="no">Codice Fiscale</Label>
                        <Input
                          id={`associati.${index}.codice_fiscale`}
                          name={`associati.${index}.codice_fiscale`}
                          autoComplete="off"
                          spellCheck="false"
                          value={associato.codice_fiscale}
                          className="text-uppercase"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          valid={!errors.associati?.[index]?.codice_fiscale && touched.associati?.[index]?.codice_fiscale}
                          invalid={errors.associati?.[index]?.codice_fiscale && touched.associati?.[index]?.codice_fiscale}
                        />
                      </Col>
                      <Col xs="12" sm="3" md="2">      
                        <Label for={`associati.${index}.importo`}>Importo</Label>
                        <Input
                          id={`associati.${index}.importo`}
                          type="select"
                          value={associato.importo}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          valid={!errors.associati?.[index]?.importo && touched.associati?.[index]?.importo}
                          invalid={errors.associati?.[index]?.importo && touched.associati?.[index]?.importo}
                        >
                        <option value="">Scegli</option>
                        <option value="55">55 euro (ordinario)</option>
                        <option value="60">60 euro (sostenitore)</option>
                        </Input>
                      </Col>  
                      <Col xs="1" sm="1" md ="1" className="d-flex align-items-end">
                        <Button color="danger" id={`tooltip-${index}`} 
                                onClick={() => {
                                  if (arrayHelpers.form.values.associati.length > 1) {
                                    arrayHelpers.remove(index);
                                    toggleTooltip(index);
                                  }
                                }}>X
                        </Button>
                        <Tooltip
                          placement="top"
                          isOpen={tooltipOpen[index]}
                          target={`tooltip-${index}`}
                          toggle={() => toggleTooltip(index)}
                        >
                          Rimuovi socio
                        </Tooltip>                      
                      </Col>
                    </FormGroup>
                  </div>
                ))
              ) : (
                <div>Nessun associato aggiunto. Clicca il pulsante per aggiungerne uno.</div>
              )}
              <Button color="primary" className="d-flex justify-content-center" onClick={() => arrayHelpers.push({ nome: '', cognome: '', codice_fiscale: '' })}>
                Aggiungi socio
              </Button>
              <Alert color="warning">
                  IMPORTANTE: se hai fatto un bonifico cumulativo di più quote, ricorda di aggiungere i dati di tutti i soci utilizzando il pulsante "Aggiungi socio"
              </Alert>
            </div>
          )}
        />
        <FormGroup row>
          <Col>{' '}</Col>
        </FormGroup>  
        <FormGroup row>
        <Col>  
          <Label for="email">Email richiedente</Label>
          <Input
            id="email"
            type="email"
            value={values.email}
            onChange={handleChange}
            onBlur={handleBlur}
            valid={!errors.email && touched.email}
            invalid={errors.email && touched.email}
           />
        </Col>  
        <FormFeedback>{errors.email}</FormFeedback>
        </FormGroup>

        <FormGroup row>
          <Col>  
            <Label for="emailConferma">Conferma Email</Label>
            <Input
              id="emailConferma"
              type="email"
              value={values.emailConferma}
              onChange={handleChange}
              onBlur={handleBlur}
              valid={!errors.emailConferma && touched.emailConferma}
              invalid={errors.emailConferma && touched.emailConferma}
            />
            <FormFeedback>{errors.emailConferma}</FormFeedback>
          </Col>  
        </FormGroup>

        <FormGroup row>
        <Col>  
          <Label for="file_pagamento">Bonifico</Label>
          <Input
            id="file_pagamento"
            type="file"
            value={values.bonifico}
            onBlur={handleBlur}
            valid={!errors.file_pagamento && touched.file_pagamento}
            invalid={(errors.file_pagamento && touched.file_pagamento) ||
                    (values.file_pagamento && values.file_pagamento.size > (10 * 1024 * 1024))}
            onChange={(event) => {
              setFieldValue('file_pagamento', event.currentTarget.files[0]);
            }} />
        </Col>  
        </FormGroup>

        <FormGroup row>
        <Col>  
          <Label for="note">Note</Label>
          <Input
            id="note"
            type="text"
            value={values.note}
            onChange={handleChange}
            onBlur={handleBlur}
            valid={!errors.note && touched.note}
            invalid={errors.note && touched.note}
           />
        </Col>  
        <FormFeedback>{errors.note}</FormFeedback>
        </FormGroup>

        {/* Campo Termini e Condizioni */}
        <FormGroup switch>
          <Col>
            <Input
              type="checkbox"
              id="condizioni"
              name="condizioni"
              checked={values.condizioni}
              onChange={handleChange}
              onBlur={handleBlur}
              invalid={errors.condizioni && touched.condizioni}
            />
            {' '}
            <Label for="condizioni" check>Accetto le <Badge color="warning" onClick={toggle} className="">condizioni</Badge></Label>
            {touched.condizioni && errors.condizioni && <div className="invalid-feedback">{errors.condizioni}</div>}
          </Col>  
        </FormGroup>

        {/* Modale Termini e Condizioni */}
        <Modal isOpen={modal} toggle={toggle}>
          <ModalHeader toggle={toggle}>Termini e Condizioni</ModalHeader>
          <ModalBody>
          Informativa ai sensi e per gli effetti dell’art. 13 del D.Lgs. 196/2003 ed art. 14 del GDPR UE 2016/679 relativi alla tutela del trattamento dei dati personali

Ai sensi dell’art 13 del D. Lgs. 196/2003 e dell’art. 14 del GDPR UE 2016/679 relativi alla tutela del trattamento dei dati personali, ed in relazione ai dati di cui l’Associazione IL SORRISO DI ISA- ETS è in possesso e di cui verrà in possesso, Ti forniamo le seguenti informazioni. L’ Associazione è impegnata ad effettuare ogni trattamento di dati personali nel rispetto dei principi di correttezza, di liceità e trasparenza, tutelando la Tua riservatezza e Tuoi diritti.

Tipologie di dati raccolti
a) I dati personali comuni raccolti e trattati dalla scrivente rientrano nella categoria dei dati identificativi (in particolare a titolo esemplificativo e non esaustivo: nominativo, indirizzo, numero di telefono, codice fiscale, età, sesso, luogo e data di nascita, indirizzo e-mail);
b) i dati particolari ex art. 9 REG. UE 679/2016 raccolti e trattati dalla scrivente.

Finalità del trattamento
Trattiamo i Tuoi dati anagrafici, il Tuo indirizzo, anche di posta elettronica, e numero telefonico ed i dati relativi alle modalità di pagamento della quota associativa/donazione (coordinate bancarie) ed ogni altro dato personale, necessario al perseguimento dello scopo associativo ed in particolare per la gestione del rapporto associativo: iscrizione nel libro soci, eventuale accensione di polizza assicurativa, invio di comunicazioni e di materiale informativo sull’attività dell’Associazione.

Modalità del trattamento
Il trattamento dei dati avviene mediante l’utilizzo di strumenti e procedure idonei a garantirne la sicurezza e la riservatezza e potrà essere effettuato sia mediante supporti cartacei, sia con l’ausilio di mezzi informatici.

Obbligo o facoltà di conferire i dati
Per quanto concerne i dati che siamo obbligati a conoscere, al fine di adempiere agli obblighi previsti da leggi, il loro mancato conferimento da parte Vostra comporta l’impossibilità di instaurare o proseguire il rapporto associativo, nei limiti in cui tali dati sono necessari all’esecuzione dello stesso.

Comunicazione e diffusione
I dati personali non potranno essere diffusi in alcun modo salvo che ciò non corrisponda ad un preciso obbligo di legge o ad un ordine di autorità. Tuttavia i dati anagrafici, limitatamente al nome e cognome, potranno essere eventualmente pubblicati sul sito internet dell’Associazione e/o su brochure e periodici cartacei al solo fine di promuovere la cultura della prevenzione e diffondere informazioni sulle iniziative dell’Associazione stessa. I dati potranno essere comunicati ad enti pubblici, o ad eventuali compagnie di assicurazione. Potranno venire a conoscenza dei Tuoi dati, in qualità di incaricati del trattamento o responsabili, i seguenti soggetti:
- altri enti del terzo settore o enti pubblici con cui l’associazione collabori per la realizzazione di specifici progetti.
- eventuali compagnie di assicurazione
- enti pubblici cui siamo tenuti per legge o convenzione a conferire i dati.

I dati personali possono essere trasferiti verso Paesi dell’Unione Europea e verso Paesi terzi nell’ambito delle finalità sopra evidenziate.

Diritti dell’interessato
Ai sensi degli artt. dal 15 al 22 del GDPR UE 679/2016 Ti vengono conferiti specifici diritti, il cui testo completo è consultabile presso la sede dell’Associazione. In particolare puoi esercitare nei confronti dell’Associazione i seguenti diritti:
- ottenere la conferma dell’esistenza di dati personali che Ti riguardano, e la comunicazione in forma intelligibile;
- ottenere l’indicazione dell’origine dei dati personali, nonché della finalità e modalità del trattamento;
- ottenere l’indicazione della logica applicata nei trattamenti effettuati con l’ausilio di strumenti elettronici; - ottenere l’aggiornamento, la rettifica, ovvero quando di interesse, l’integrazione dei dati;
- ottenere la cancellazione, la trasformazione in forma anonima o il blocco dei dati trattati in violazione di legge;          
- ottenere la cancellazione, la trasformazione in forma anonima o il blocco dei dati di cui non è necessaria la conservazione, in relazione agli scopi per i quali i dati sono stati raccolti o successivamente trattati;
- ottenere l’attestazione che l’aggiornamento, la rettifica, l’integrazione, la cancellazione, la trasformazione in forma anonima o il blocco sono stati portati a conoscenza, anche per quanto riguarda il contenuto, di coloro ai quali i dati sono stati comunicati o diffusi, tranne che nei casi in cui tale adempimento si riveli impossibile o comporti un impiego di mezzi manifestamente sproporzionato rispetto al diritto tutelato;
- opporti in tutto o in parte, per motivi legittimi, al trattamento dei dati personali che Ti riguardano, ancorché pertinenti allo scopo della raccolta;
- opporti, in tutto o in parte, al trattamento di dati personali che Ti riguardano al fine di invio di materiale pubblicitario. Per esercitare tali diritti puoi rivolgerti all’Associazione, nella persona del suo Presidente.

Titolare del trattamento
Il Titolare del trattamento dei dati è l’Associazione IL SORRISO DI ISA - ETS C.F. 97804350011, con sede legale in Torino Via Moretta n. 7, e-mail info@ilsorrisodiisaets.org pec: ilsorrisodiisa@pec.it, tel. 345/83.88.127.
Per esercitare i diritti previsti dalla normativa vigente e sopra elencati, l’Interessato dovrà rivolgere richiesta scritta mediante i suddetti canali.
          </ModalBody>
        </Modal>
  
        <ReCaptchaField setFieldValue={setFieldValue} values={values} />
        <Input
          type="hidden"
          name="recaptcha"
          value={values.recaptcha}
          onChange={handleChange}
          valid={!errors.recaptcha && touched.recaptcha}
          invalid={errors.recaptcha && touched.recaptcha}
        />

        <FormGroup row>
          <Col>{' '}</Col>
        </FormGroup>  
        <Button color="primary" type="submit" disabled={isSubmitting}>Invia</Button>
      </form>
    </Container>
  );
};

const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
const RinnovoForm = withFormik({
  mapPropsToValues: () => ({
    associati: [{ nome: '', cognome: '', codice_fiscale: '', importo: '' }],
    file_pagamento: null,
    condizioni: false,
    note: '',
    email: '',
    emailConferma: '',
    recaptcha: '',
    }),
    validationSchema: Yup.object().shape({
      associati: Yup.array().of(
        Yup.object().shape({
          nome: Yup.string()
            .required(' ')
            .max(100, 'il nome può contenere al massimo 100 caratteri').nullable(),
          cognome: Yup.string()
            .required(' ')
            .max(100, 'il cognome può contenere al massimo 100 caratteri').nullable(),
          importo: Yup.string()
            .required(' '),
          codice_fiscale: Yup.string()
            .required(' ')
            .matches(/^(?:[A-Z][AEIOU][AEIOUX]|[AEIOU]X{2}|[B-DF-HJ-NP-TV-Z]{2}[A-Z]){2}(?:[\dLMNP-V]{2}(?:[A-EHLMPR-T](?:[04LQ][1-9MNP-V]|[15MR][\dLMNP-V]|[26NS][0-8LMNP-U])|[DHPS][37PT][0L]|[ACELMRT][37PT][01LM]|[AC-EHLMPR-T][26NS][9V])|(?:[02468LNQSU][048LQU]|[13579MPRTV][26NS])B[26NS][9V])(?:[A-MZ][1-9MNP-V][\dLMNP-V]{2}|[A-M][0L](?:[1-9MNP-V][\dLMNP-V]|[0L][1-9MNP-V]))[A-Z]$/i,
             'Codice fiscale non valido').nullable(),
        })
      ),
      email: Yup.string()
        .trim()
        .matches(emailRegex, 'Inserisci un indirizzo email valido')
        .email('Formato email non corretto')
        .max(255, 'L\'email non può superare i 255 caratteri')
        .required('L\'email è obbligatoria'),
      emailConferma: Yup.string()
        .oneOf([Yup.ref('email'), null], 'Le email non coincidono')
        .required('Conferma la tua email'),
      file_pagamento: Yup.mixed()
        .required('Il campo Bonifico è obbligatorio')
        .test('fileSize', 'La dimensione massima consentita è di 10MB', (value) => {
          if (value) {
            const maxSize = 10 * 1024 * 1024;
            return value.size <= maxSize;
          }
          return true;
        }),
      note: Yup.string()
        .max(100, 'Le note devono avere al massimo 100 caratteri').nullable(),
      condizioni: Yup.bool()
        .oneOf([true], 'IMPORTANTE: Occorre accettare le condizioni di adesione al servizio e trattamento dei dati personali'),
    }),
  handleSubmit: (values, { setSubmitting, resetForm, setErrors, setFieldValue, setStatus }) => {
    const formData = new FormData();
    values.associati.forEach((associato, index) => {
      formData.append(`associati[${index}][nome]`, associato.nome);
      formData.append(`associati[${index}][cognome]`, associato.cognome);
      formData.append(`associati[${index}][codice_fiscale]`, associato.codice_fiscale);
      formData.append(`associati[${index}][importo]`, associato.importo);
    });
    formData.append('email', values.email);
    formData.append('note', values.note);
    formData.append('file_pagamento', values.file_pagamento);
    formData.append('g-recaptcha-response', values.recaptcha);

    axios.post(process.env.REACT_APP_BASE_SERVER_URI+'/site/insrichiestarinnovo', formData)
      .then((response) => {
        setSubmitting(false);
        if (response.status !== 201) {
          response.text()
          .then(msg=>{
            var errmsg = "Si è verificato un problema durante l'inserimento della richiesta.";
            if(msg){
              errmsg += " " + msg; 
            }
            setStatus({res: false, msg: errmsg});
            scrollToTop();
            setFieldValue('recaptcha', '');
          });
        }else{
          resetForm();
          document.getElementById("file_pagamento").value = "";

          setStatus({res:true, msg:"La richiesta è stata inserita. Riceverà una mail di conferma all'indirizzo indicato"});
          scrollToTop();
          setFieldValue('recaptcha', '');
        }
      })
      .catch(error => {
        setSubmitting(false);
        var errmsg = "Si è verificato un problema durante l'inserimento della richiesta. ";
        if(error.response && error.response.data.error){
          errmsg += " " + error.response.data.error; 
        }else{
          errmsg += " Servizio non disponibile"
        }
        setStatus({res: false, msg: errmsg});
        scrollToTop();
        setFieldValue('recaptcha', '');
      });
  },
})(RinnovoAssociati);

export default RinnovoForm;
